import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthImpersonationService, IMPERSONATION_HEADER_USER_ID, JwtService } from '../providers';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly jwtService: JwtService,
    private readonly authImporsinatorService: AuthImpersonationService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const curusername = this.jwtService.getUsername();
    if (req.url.endsWith('token') || req.url.endsWith('logout')) {
      return next.handle(req);
    }

    const token = this.jwtService.getToken();
    if (token === undefined) {  // expire or empty token
      const refreshToken = window.localStorage.vivent_jwt_refresh_token;
      if (!refreshToken) {
        this.jwtService.destroyToken();
        return next.handle(req);
      }
      return this.jwtService.refreshToken(refreshToken).pipe(
        switchMap((newToken: any) => {
          this.jwtService.saveToken(
            newToken.access_token,
            newToken.refresh_token,
            new Date().getTime() + newToken.expires_in * 1000, curusername
          );

          req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${newToken.access_token}`
            }
          });
          return next.handle(req);
        }),
        catchError(refreshError => {
          console.log('Error refreshing token:', refreshError);
          this.jwtService.destroyToken();
          return next.handle(req);
        })
      );
    }
    else {
      const requestHeaders: Partial<any> = {
          Authorization: `Bearer ${token}`
      };

      if (this.authImporsinatorService.isImpersonating()) {
        const impersonatedUser = this.authImporsinatorService.getStateValue().impersonatedUser;
        requestHeaders[IMPERSONATION_HEADER_USER_ID] = impersonatedUser;
      }

      req = req.clone({
        setHeaders: requestHeaders
      });
      return next.handle(req);
    }
  }
}
